// extracted by mini-css-extract-plugin
module.exports = {"container":"VerticalGradientText_container__YZZX2"};